import i18next from 'i18next';
import moment from 'moment-timezone';
import React from 'react';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import { InpulseLabel } from '@commons/DeepsightComponents';
import { numberToFixed } from '@commons/utils/format';
import { Tags } from '@commons/Tags';

const PENDING_STATUS = 'PENDING';

const COLOR_MAP = {
  SUCCESS: 'green',
  FAILURE: 'red',
  STOPPED: 'grey',
  PENDING: 'orange',
};

export const getColumnsSettings = (translatedStoresName) => [
  {
    id: 'request_launched_at',
    name: i18next.t('GENERAL.DATE'),
    propertyKey: 'request_launched_at',
    render: (date) => moment(date).format(DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR_HOUR_MINUTES),
  },
  {
    id: 'name',
    name: i18next.t('GENERAL.NAME'),
    propertyKey: 'name',
    disableSort: true,
    render: (name) =>
      i18next.t(`BACKOFFICE.TASKS.NAME.${name.toUpperCase()}`, {
        storeNamePlural: translatedStoresName,
      }),
  },
  {
    id: 'formattedParams',
    name: i18next.t('BACKOFFICE.TASKS.PARAMS'),
    propertyKey: 'formattedParams',
    disableSort: true,
    render: (formattedParams) => <Tags items={formattedParams} />,
    displayBigger: true,
    large: true,
  },
  {
    id: 'formattedStatus',
    name: i18next.t('GENERAL.STATUS'),
    propertyKey: 'formattedStatus',
    disableSort: true,
    render: ({ status, progress }) =>
      status ? (
        <InpulseLabel
          color={COLOR_MAP[status]}
          text={
            i18next.t(`BACKOFFICE.TASKS.STATUS.${status}`) +
            (status === PENDING_STATUS ? ` (${numberToFixed((progress || 0) * 100, 0)}%)` : '')
          }
        />
      ) : (
        '-'
      ),
  },
];

export default {
  getColumnsSettings,
};
